<div class="btn-wrapper" [ngClass]="{'fr': language === 'fr'}">
    <ng-container *ngFor="let button of params.actions">
        <ng-container *ngIf="isButtonVisible(button, params) && button.id !== 'select'">
            <button class="action-button" mat-flat-button
                [disabled]="isButtonDisabled(button, params)"
                attr.data-cy="{{button.id + '-' + params.rowIndex}}"
                (click)="onClick(button.id)">
                <mat-icon matSuffix> {{ button.matSuffix }}</mat-icon>
                <div class="action-button-text">{{button.label | translate}}</div>
            </button>
        </ng-container>
        <ng-container *ngIf="isButtonVisible(button, params) && button.id === 'select'">
            <button class="basic-button-narrow carm-primary-button business-button-selection"
                [class.hide]="isButtonDisabled(button, params)"
                attr.data-cy="{{button.id + '-' + params.rowIndex}}"
                (click)="onClick(button.id)">
                {{'button.select' | translate}}
            </button>
        </ng-container>
    </ng-container>
</div>
